import React from 'react';

const HourInput = ({
  label,
  name,
  placeholder = 'HH:MM',
  control,
  errors,
  rules,
  userRoles
}) => {
  const handleMask = (value) => {
    const numericValue = value.replace(/\D/g, '');
    const hours = numericValue.slice(0, 2);
    const minutes = numericValue.slice(2, 4);
    if (numericValue.length <= 2) {
      return hours;
    }
    return `${hours}:${minutes}`;
  };

  const validateHour = (value) => {
    if (!value) {
      return true;
    }
    if (!/^\d{2}:\d{2}$/.test(value)) {
      return 'Formato inválido. Use HH:MM';
    }
    const [hours, minutes] = value.split(':').map(Number);
    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      return 'Hora inválida. Use o formato 24h (HH:MM)';
    }
    return true;
  };

  return (
    <div className="form-group mb-3">
      <label htmlFor={name} className='mb-1'>{label}</label>
      <input
        id={name}
        placeholder={placeholder}
        {...control.register(name, {
          ...rules,
          validate: validateHour,
          onChange: (e) => {
            e.target.value = handleMask(e.target.value);
          },
        })}
        readOnly={userRoles}
        autoComplete='off'
        className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
      />
      {errors[name] && <div className="invalid-feedback">{errors[name].message}</div>}
    </div>
  );
};

export default HourInput;
